import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { array, func, object, string } from 'prop-types';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import SlideoutBody from 'ps-components/Slideout/Body/SlideoutBody';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import SlideoutFooterStandardButtons from 'ps-components/Slideout/Footer/SlideoutFooterStandardButtons';
import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';
import './AddWidgetsSlideout.scss';
import { showSlideout, hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import Placeholder from '../../MarketPricing/Placeholder/Placeholder';
import CardMappings from './../CardMappings';
import classnames from 'classnames';
import { SLIDEOUTS } from '../../Slideout/Slideouts';

const tabList = ['Default Widgets', 'Tableau Reports'];

AddWidgetsSlideout.propTypes = {
  slideout: object,
  currentCards: array,
  toBeAdded: array,
  setToBeAdded: func,
  hideSlideout: func,
  viewName: string
};

export function AddWidgetsSlideout(props) {
  const { slideout, currentCards, setToBeAdded, hideSlideout, viewName } = props;

  const [activeTab, setActiveTab] = useState(0);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (!slideout.open) {
      setSelected([]);
      setActiveTab(0);
    }
  }, [slideout.open]);

  function contactSupport() {
    showSlideout(SLIDEOUTS.CONTACT_SUPPORT_SLIDEOUT);
  }

  const headerText = (
    <span>
      <div className="slideout-header-subtext">Add Widgets to Dashboard</div>
      {viewName}
    </span>
  );

  function tabClick(tab) {
    setActiveTab(tab);
  }

  function addCards() {
    setToBeAdded(selected);
    hideSlideout();
  }

  return (
    <React.Fragment>
      <SlideoutHeader title={headerText} doClose={hideSlideout} />
      <SlideoutBody>
        <ViewSwitcher
          className="dashboard-add-widgets__view-switcher"
          isSticky={false}
          tabList={tabList}
          activeTab={activeTab}
          tabSwitch={tabClick}
        />
        <div className="dashboard-add-widgets__card-list">
          {currentCards.length ? (
            currentCards.map((cardId, index) => {
              const title = CardMappings[cardId].title;
              const thumbnail = CardMappings[cardId].thumbnail;
              if (title && thumbnail)
                return (
                  <ThumbnailCard
                    key={index}
                    id={cardId}
                    selected={selected}
                    setSelected={setSelected}
                    title={title}
                    imgSrc={thumbnail}
                  />
                );
              return null;
            })
          ) : (
            <Placeholder
              containerClassName="dashboard-add-widgets__card-list-placeholder"
              primaryText="All default widgets have been added to this dashboard already"
              secondaryText="Please check your selected dashboard view"
            />
          )}
        </div>
      </SlideoutBody>
      <SlideoutFooter footerClassName="struc-bulk-copy__footer" isBoxShadowTheme={true}>
        <SlideoutFooterStandardButtons
          applyText={selected.length ? `Add ${selected.length} Widgets` : 'Select more widgets'}
          doCancel={hideSlideout}
          doApply={addCards}
          isApplyDisabled={selected.length === 0}
        />
      </SlideoutFooter>
    </React.Fragment>
  );
}

const mapStateToProps = ({ structureBulkCopy, groups }) => {
  return {};
};

const actions = { hideSlideout };

export default connect(mapStateToProps, actions)(withRouter(AddWidgetsSlideout));

function ThumbnailCard(props) {
  const { imgSrc, title, id, selected, setSelected } = props;
  const isSelected = selected.find(cardId => cardId === id);

  function toggleCard() {
    const isSelected = selected.find(cardId => cardId === id);
    if (isSelected) {
      setSelected(selected.filter(cardId => cardId !== id));
    } else {
      setSelected(true);
      selected.unshift(id);
      setSelected([...selected]);
    }
  }
  return (
    <div onClick={toggleCard} className={classnames({ selected: isSelected }, 'dashboard-add-widgets__thumbnail-card')}>
      <div className="thumb-title">{title || 'Title'}</div>
      {imgSrc && <img className="thumb-image" src={imgSrc} />}
      {!imgSrc && <div className="thumb-image">No thumbnail image found.</div>}
    </div>
  );
}
